var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwilio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 92.309C64.41 92.309 64.41 67.691 48 67.691C31.59 67.691 31.59 92.309 48 92.309ZM48 60.309C64.41 60.309 64.41 35.691 48 35.691C31.59 35.691 31.59 60.31 48 60.31V60.309ZM80 92.309C96.41 92.309 96.41 67.691 80 67.691C63.59 67.691 63.59 92.309 80 92.309ZM80 60.309C96.41 60.309 96.41 35.691 80 35.691C63.59 35.691 63.59 60.31 80 60.31V60.309ZM64 0C98.664 0 128 29.336 128 64C128 98.664 98.664 128 64 128C29.336 128 0 98.664 0 64C0 29.336 29.336 0 64 0ZM64 17.23C38.242 17.23 17.23 37.516 17.23 63.14C17.23 88.766 38.242 110.77 64 110.77C89.758 110.77 110.77 88.766 110.77 63.14C110.77 37.516 89.758 17.23 64 17.23Z",
    fill: "#F22F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwilio);
export default __webpack_public_path__ + "static/media/twilio.0c5d83bfb5d445368d7e6ab74437ee64.svg";
export { ForwardRef as ReactComponent };